import React from "react";
import styled from "styled-components";
import { Card, Box } from "rebass";
import { CardHeader } from "./CardHeader";
import { CloseButton } from "./CloseButton";

export const Modal: React.FC<{
  headerText?: string;
  headerElement?: JSX.Element;
  dataTour?: string
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  overflow?: string;
  backgroundColor?: string;
}> = ({ children, headerText, headerElement, setIsOpen, isOpen, dataTour= "", overflow= "show", backgroundColor="white" }) => {
  if (!isOpen) {
    return <></>;
  }

  const header = (headerText || headerElement)?
      <CardHeader
          right={
              <CloseButton
                  onClick={() => {
                      setIsOpen(false);
                  }}
              />
          }
          left={headerElement}
          headerText={headerText}
    />
  : undefined

  return (
    <Overlay
      onClick={() => {
        setIsOpen(false);
      }}
    >
      <Box
        data-tour={dataTour}
        width="auto"
        overflow={overflow}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <Card backgroundColor={backgroundColor}>
          {header}
          {children}
        </Card>
      </Box>
    </Overlay>
  );
};

const Overlay = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0);
  backdrop-filter: blur(10px);
  z-index: 100;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;
